import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Profiles from "./pages/Profiles";
import Browse from "./pages/Browse";
import SearchPage from "./pages/Search";
import Detail from "./pages/Detail";
import Watch from "./pages/Watch";
import MyList from "./pages/MyList";
import Pricing from "./pages/Pricing";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import Share from "./pages/Share";
import Live from "./pages/Live";
import LivePlayer from "./pages/LivePlayer";
import Showtimes from "./pages/Showtimes";
import Festival from "./pages/Festival";
import FilmDetail from "./pages/FilmDetail";
import FestivalSubmit from "./pages/FestivalSubmit";
import FilmmakerDashboard from "./pages/FilmmakerDashboard";
import FestivalModeration from "./pages/FestivalModeration";
import LaurelsWall from "./pages/LaurelsWall";
import FilmmakerProfile from "./pages/FilmmakerProfile";
import FestivalFollowing from "./pages/FestivalFollowing";
import Dashboard from "./pages/Dashboard";
import Screens from "./pages/Screens";
import ScreenPlayer from "./pages/ScreenPlayer";
import CreatorApply from "./pages/CreatorApply";
import CreatorProfile from "./pages/CreatorProfile";
import CreatorsLeaderboard from "./pages/CreatorsLeaderboard";
import CredentialVerify from "./pages/CredentialVerify";
import JuryDashboard from "./pages/JuryDashboard";
import JuryProfile from "./pages/JuryProfile";
import ProtectedRoute from "./components/ProtectedRoute";

function Router() {
  const loc = useLocation();
  // Intercept OAuth fragment callback BEFORE normal routes
  if (loc.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/festival/verify/:cid" element={<CredentialVerify />} />
      <Route path="/jury/dashboard" element={<ProtectedRoute><JuryDashboard /></ProtectedRoute>} />
      <Route path="/jury/:slug" element={<JuryProfile />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/profiles" element={<ProtectedRoute><Profiles /></ProtectedRoute>} />
      <Route path="/browse" element={<ProtectedRoute requireProfile><Browse /></ProtectedRoute>} />
      <Route path="/search" element={<ProtectedRoute requireProfile><SearchPage /></ProtectedRoute>} />
      <Route path="/title/:id" element={<ProtectedRoute requireProfile><Detail /></ProtectedRoute>} />
      <Route path="/watch/:id" element={<ProtectedRoute requireProfile><Watch /></ProtectedRoute>} />
      <Route path="/mylist" element={<ProtectedRoute requireProfile><MyList /></ProtectedRoute>} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/share/:id" element={<Share />} />
      <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/creator/apply" element={<ProtectedRoute><CreatorApply /></ProtectedRoute>} />
      <Route path="/creator/:userId" element={<CreatorProfile />} />
      <Route path="/creators" element={<CreatorsLeaderboard />} />
      <Route path="/live" element={<ProtectedRoute requireProfile><Live /></ProtectedRoute>} />
      <Route path="/live/showtimes" element={<ProtectedRoute requireProfile><Showtimes /></ProtectedRoute>} />
      <Route path="/live/:slug" element={<ProtectedRoute requireProfile><LivePlayer /></ProtectedRoute>} />
      <Route path="/screens" element={<ProtectedRoute requireProfile><Screens /></ProtectedRoute>} />
      <Route path="/screens/:n" element={<ProtectedRoute requireProfile><ScreenPlayer /></ProtectedRoute>} />
      <Route path="/festival" element={<Festival />} />
      <Route path="/festival/laurels" element={<LaurelsWall />} />
      <Route path="/festival/films/:id" element={<FilmDetail />} />
      <Route path="/festival/submit" element={<ProtectedRoute><FestivalSubmit /></ProtectedRoute>} />
      <Route path="/festival/dashboard" element={<ProtectedRoute><FilmmakerDashboard /></ProtectedRoute>} />
      <Route path="/admin/festival" element={<ProtectedRoute><FestivalModeration /></ProtectedRoute>} />
      <Route path="/filmmaker/:id" element={<FilmmakerProfile />} />
      <Route path="/festival/following" element={<ProtectedRoute><FestivalFollowing /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Router />
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
